/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type MilestoneType from '@linc-technologies/linced-common/enums/milestone-type';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import type MilestoneSet from 'linced-admin/models/milestones/milestone-set';
import type Set from 'linced-admin/models/milestones/set';

// Proto: milestones.MilestoneTemplate.
export default class Milestone extends Model {
  declare [Type]: 'milestones/milestone';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof MilestoneType> | 0;

  @attr('number', { defaultValue: 0 })
  declare duration: number;

  @attr('number', { defaultValue: 0 })
  declare yearLevel: number;

  @attr('number', { defaultValue: 0 })
  declare month: number;

  @attr('number', { defaultValue: 0 })
  declare day: number;

  @attr('boolean', { defaultValue: false })
  declare isInterim: boolean;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @belongsTo('milestones/set', { async: true, inverse: 'milestones' })
  declare templateSetId: AsyncBelongsTo<Set>;

  @alias('templateSetId')
  declare templateSet: AsyncBelongsTo<Set>;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @belongsTo('milestones/milestone-set', { async: true, inverse: 'milestones' })
  declare milestoneSetTemplateId: AsyncBelongsTo<MilestoneSet>;

  @alias('milestoneSetTemplateId')
  declare milestoneSetTemplate: AsyncBelongsTo<MilestoneSet>;
}
